import React from "react";
import { Table, Card } from "react-bootstrap";
import DateRenderer from "./renderers/DateRenderer";

interface LeaveOfAbsenceViewProps
{
    data: LeavesOfAbsences;
}

export default class LeaveOfAbsenceView extends React.Component<LeaveOfAbsenceViewProps>
{
    render(): React.ReactNode
    {
        return <div className={"mt-5"}>
            <h2>Leaves and Academic Actions</h2>
            {
                (this.props.data.leavesOfAbsence && this.props.data.leavesOfAbsence.length > 0)
                    ?
                    <Card className={"border mb-3"}>
                        <Table responsive className="list">
                            <thead>
                                <tr>
                                    <th>Term</th>
                                    <th>Date</th>
                                    <th>Reason/Registration Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.data.leavesOfAbsence.map((leave: LeaveAbsences, i: number) => 
                                    {
                                        return <tr key={i}>
                                            <td className="td-normal">{leave.termCode ? leave.termCode : " - "}</td>
                                            <td className="td-normal"><DateRenderer value={leave.withdrawDate} type={"short"} /></td>
                                            <td><b>{leave.withdrawDescription ? leave.withdrawDescription : " - "}</b></td>
                                        </tr>;
                                    })
                                }
                            </tbody>
                        </Table>
                    </Card>
                    :
                    <div id='error'>
                        <Card className={"border mb-3"}>
                            <Table responsive className="list">
                                <thead>
                                    <tr>
                                        <th>Term</th>
                                        <th>Date</th>
                                        <th>Reason/Registration Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="text-center">
                                        <td colSpan={3}>
                                            <p className="error-text">No Leaves and Academic Admins data available</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card>
                    </div>
            }
        </div>;
    }
}